import { Box } from "@material-ui/core";
import { ColorButton } from "material-ui-color";
import { Fragment, useMemo } from "react";
import { useAmenitiesColorMap } from "../../../graphql/hooks";
import { LoadWrapper } from "../load_wrapper";

export interface AmenitiesColorsLegendProps {}

export function AmenitiesColorsLegend(props) {
  const { amenityColorMap, loading } = useAmenitiesColorMap();

  const amenityColorEntries = useMemo(
    () => Object.entries(amenityColorMap),
    [amenityColorMap]
  );

  return (
    <LoadWrapper loading={loading}>
      <Box style={{ display: "flex", gap: "1rem" }}>
        {amenityColorEntries.map(([, amenity], index) => (
          <Fragment key={index}>
            <ColorButton color={amenity.color} /> &nbsp; {amenity.name}
          </Fragment>
        ))}
      </Box>
    </LoadWrapper>
  );
}
